import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const getConnectionDetails = () =>
  axios.get('https://iplist.cc/api').then((response) => response.data);
